/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Tier_LeadInputs */

const en_fw_bm_tier_lead = /** @type {(inputs: Fw_Bm_Tier_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light, standard and heavy tasks behave differently. Same agent, different odds.`)
};

const id_fw_bm_tier_lead = /** @type {(inputs: Fw_Bm_Tier_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task ringan, standar, dan berat berperilaku beda. Agen sama, peluang beda.`)
};

/**
* | output |
* | --- |
* | "Light, standard and heavy tasks behave differently. Same agent, different odds." |
*
* @param {Fw_Bm_Tier_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_tier_lead = /** @type {((inputs?: Fw_Bm_Tier_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Tier_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_tier_lead(inputs)
	return en_fw_bm_tier_lead(inputs)
});